import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "phone"
})

export class PhonePipe implements PipeTransform{
    transform(phoneNumIn) {
        if (!phoneNumIn) {
            return ''
        }

        let value = phoneNumIn.toString().trim().replace(/^\+/, '');

        if (value.match(/[^0-9]/)) {
            return phoneNumIn;
        }

        let area, number;
        switch (value.length) {
            case 1:
            case 2:
            case 3:
                area = value;
                break;
            default:
                area = value.slice(0, 3);
                number = value.slice(3);
        }

        if (number) {
            if (number.length > 3) {
                number = number.slice(0, 3) + '-' + number.slice(3, 7);
            }

            return ("(" + area + ") " + number).trim();
        } else {
            return area;
        }
    }
}
